import imageUrlBuilder from "@sanity/image-url";
import { SanityImageSource } from "@sanity/image-url/lib/types/types";
import NextImage from "next/image";

import { client } from "@/sanity/lib/client";

import styles from "./styles.module.css";

export const Image = ({ value, width = 1120, height = 760 }) => {
  const builder = imageUrlBuilder(client());
  const urlFor = (source: SanityImageSource) => builder.image(source);

  return (
    <div className={styles.img}>
      <NextImage
        src={urlFor(value).width(width).height(height).fit("fill").url()}
        alt={value.alt || " "}
        width={width}
        height={height}
        style={{
          maxWidth: "100%",
          maxHeight: "300",
          height: "auto",
        }}
      />
    </div>
  );
};
